/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/sort-type-union-intersection-members */
/* eslint-disable @typescript-eslint/consistent-indexed-object-style */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/require-array-sort-compare */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-nested-ternary */
/* eslint-disable object-curly-newline */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-extra-parens */
import React, { useState, useMemo } from 'react';
import { formatTenantName } from 'utils/formatTenantName';
import {
  IconButton, Typography, Button,
  FormControl, Checkbox, FormControlLabel,
  Dialog, DialogContent, DialogActions,
  CircularProgress, TextField, Tooltip,
  Menu, MenuItem, ListItemIcon, ListItemText,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CheckIcon from '@mui/icons-material/Check';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CommentIcon from '@mui/icons-material/Comment';
import EditIcon from '@mui/icons-material/Edit';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Popper from '@mui/material/Popper';
import PopupState, { bindToggle, bindPopper } from 'material-ui-popup-state';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import type { Cell } from 'react-table';
import CustomTable from 'shared-components/tables/CustomTable';
import StradaSearch from 'admin/buildingSection/budget-calendar/components/StradaSearch';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useSnackbar } from 'notistack';
import CustomLoader from 'shared-components/components/CustomLoader';
import axios from 'axios';
import type { AxiosResponse } from 'axios';
import type { RootState } from 'mainStore';
import type { IDataObject } from 'formsTypes';
import type { ROFRMonitorItem, OptionType, OptionStatus } from './types';
import {
  STATUS_DISPLAY,
  STATUS_COLORS,
  ALL_STATUSES,
  ALL_OPTION_TYPES,
  ALL_OPTION_STATUSES,
  OPTION_TYPE_CONFIG,
  OPTION_STATUS_CONFIG,
} from './types';
import OptionsDetailSideSheet from './OptionsDetailSideSheet';
import './_OptionsMonitor.scss';

const RATE_STRUCTURE_LABELS: Record<string, string> = {
  fmv: 'FMV',
  fixed: 'Fixed',
  cpi: 'CPI',
};

function RateStructureCell({
  item,
  onSelect,
}: {
  item: ROFRMonitorItem;
  onSelect: (rs: string) => void;
}): JSX.Element {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const label = item.rate_structure ? (RATE_STRUCTURE_LABELS[item.rate_structure] ?? item.rate_structure) : null;
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div
        onClick={(e: React.MouseEvent<HTMLElement>): void => { e.stopPropagation(); setAnchorEl(e.currentTarget); }}
        style={{ display: 'inline-flex', alignItems: 'center', gap: '2px', cursor: 'pointer', color: label ? '#212121' : '#9CA3AF', fontStyle: label ? 'normal' : 'italic' }}
        aria-hidden='true'
      >
        <span style={{ fontSize: '13px' }}>{label ?? 'Select'}</span>
        <KeyboardArrowDownIcon style={{ fontSize: '14px', color: '#9CA3AF' }} />
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={(): void => { setAnchorEl(null); }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ style: { minWidth: '100px', marginTop: '4px' } }}
      >
        {(['fmv', 'fixed', 'cpi'] as const).map((rs) => (
          <MenuItem
            key={rs}
            onClick={(): void => { setAnchorEl(null); onSelect(rs); }}
          >
            <ListItemIcon sx={{ minWidth: '28px' }}>
              {item.rate_structure === rs && <CheckIcon style={{ fontSize: '16px', color: '#212121' }} />}
            </ListItemIcon>
            <ListItemText primary={RATE_STRUCTURE_LABELS[rs]} />
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default function OptionsContent(): JSX.Element {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [search, setSearch] = useState<string>('');
  // Multi-select filters
  const [selectedBuildings, setSelectedBuildings] = useState<string[]>([]);
  const [selectedOptionTypes, setSelectedOptionTypes] = useState<OptionType[]>([...ALL_OPTION_TYPES]);
  // Group by building toggle
  const [groupByBuilding, setGroupByBuilding] = useState<boolean>(false);
  const [collapsedGroups, setCollapsedGroups] = useState<Set<string>>(new Set());
  // Inline editing state
  const [editingTriggerId, setEditingTriggerId] = useState<number | null>(null);
  const [editingTriggerValue, setEditingTriggerValue] = useState<string>('');
  const [editingUnitSuiteId, setEditingUnitSuiteId] = useState<number | null>(null);
  const [editingUnitSuiteValue, setEditingUnitSuiteValue] = useState<string>('');
  const [editingSFId, setEditingSFId] = useState<number | null>(null);
  const [editingSFValue, setEditingSFValue] = useState<string>('');
  const [editingNoticePeriodId, setEditingNoticePeriodId] = useState<number | null>(null);
  const [editingNoticePeriodValue, setEditingNoticePeriodValue] = useState<string>('');
  // Sidesheet state
  const [showSidesheet, setShowSidesheet] = useState<boolean>(false);
  const [isClosing, setIsClosing] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<ROFRMonitorItem | null>(null);
  const [pendingStatusFromTable, setPendingStatusFromTable] = useState<OptionStatus | null>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<ROFRMonitorItem | null>(null);
  // Bulk delete state
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());
  const [bulkDeleteDialogOpen, setBulkDeleteDialogOpen] = useState<boolean>(false);
  // Filter menu anchors
  const [buildingMenuAnchor, setBuildingMenuAnchor] = useState<HTMLElement | null>(null);
  const [optionTypeMenuAnchor, setOptionTypeMenuAnchor] = useState<HTMLElement | null>(null);

  const currentWorkspace = useSelector(
    (state: RootState) => state.workspaces.currentWorkspace.currentWorkspace,
  );

  // Fetch processing leases (leases that are still being processed)
  interface ProcessingLease {
    id: number;
    tenant_name: string;
    is_processed: boolean;
    progress: number;
    message: string;
  }

  const {
    data: processingLeases = [],
  } = useQuery(
    ['get/processing-leases', currentWorkspace.id],
    async () => axios({
      url: 'api/lease/',
      method: 'get',
      params: {
        workspace: currentWorkspace.id,
      },
    }),
    {
      enabled: Boolean(currentWorkspace.id),
      refetchInterval: 10000, // Refetch every 10 seconds to check for newly processed leases
      select: (res: AxiosResponse<{ results: ProcessingLease[] }>) => res.data.results.filter((lease: ProcessingLease) => !lease.is_processed),
    },
  );

  const {
    data: rofrData,
    isLoading,
  } = useQuery(
    ['get/options-monitor', currentWorkspace.id, search],
    async () => axios({
      url: 'api/options-monitor/',
      method: 'get',
      params: {
        workspace: currentWorkspace.id,
        search,
      },
    }),
    {
      enabled: Boolean(currentWorkspace.id),
      // Always refetch: faster when processing leases exist, slower background refresh otherwise
      refetchInterval: processingLeases.length > 0 ? 5000 : 30000,
      select: (res: AxiosResponse<{ results: ROFRMonitorItem[]; next: string | null; previous: string | null }>) => res.data.results,
    },
  );

  // Helper to normalize building addresses by removing suite/unit numbers for grouping
  const normalizeAddress = (address: string | null): string | null => {
    if (!address) return null;
    // Remove common suite/unit patterns: ", Suite 100", " Suite 200", ", Unit A", " #123", etc.
    return address
      .replace(/[,\s]+(suite|ste|unit|apt|#)\s*[a-z0-9-]+$/i, '')
      .replace(/[,\s]+(suite|ste|unit|apt|#)\s*[a-z0-9-]+\s*,/i, ',')
      .trim();
  };

  // Derive unique buildings from data for filter dropdown, grouped by normalized address
  const buildings = useMemo(() => {
    if (!rofrData) return [];
    // Get all non-null property names
    const allAddresses = rofrData.map((item) => item.property_name).filter(Boolean) as string[];
    // Create a map of normalized address to display (use the normalized version for dropdown)
    const normalizedSet = new Set<string>();
    allAddresses.forEach((addr) => {
      const normalized = normalizeAddress(addr);
      if (normalized) normalizedSet.add(normalized);
    });
    return [...normalizedSet].sort((a, b) => a.localeCompare(b));
  }, [rofrData]);

  // Apply filters to data
  const filteredData = useMemo(() => {
    if (!rofrData) return [];
    return rofrData.filter((item) => {
      // Multi-select building filter
      let matchesBuilding = selectedBuildings.length === 0;
      if (!matchesBuilding && item.property_name) {
        const normalizedItem = normalizeAddress(item.property_name);
        matchesBuilding = normalizedItem !== null && selectedBuildings.includes(normalizedItem);
      }
      // Multi-select option type filter - handle null option_type
      const matchesOptionType = selectedOptionTypes.length === 0 
        || (item.option_type !== null && selectedOptionTypes.includes(item.option_type));
      return matchesBuilding && matchesOptionType;
    });
  }, [rofrData, selectedBuildings, selectedOptionTypes]);

  // Grouped data for "Group by Building" mode
  const groupedData = useMemo(() => {
    if (!groupByBuilding) return null;
    const groups: { [key: string]: ROFRMonitorItem[] } = {};
    filteredData.forEach((item) => {
      const buildingKey = normalizeAddress(item.property_name) || 'Unassigned';
      if (!groups[buildingKey]) {
        groups[buildingKey] = [];
      }
      groups[buildingKey].push(item);
    });
    return groups;
  }, [filteredData, groupByBuilding]);

  // Compute unique % of building for a group (deduplicated by tenant + unit)
  const getUniquePctOfBuilding = (items: ROFRMonitorItem[]): number | null => {
    const seen = new Set<string>();
    const total = items
      .filter((item) => item.pct_of_building != null)
      .reduce((sum, item) => {
        const key = `${(item.tenant_name || '').trim().toLowerCase()}|${(item.unit_suite || '').trim().toLowerCase()}`;
        if (seen.has(key)) return sum;
        seen.add(key);
        return sum + (item.pct_of_building || 0);
      }, 0);
    return total > 0 ? Math.round(total * 10) / 10 : null;
  };

  // Toggle building group collapse
  const toggleGroupCollapse = (buildingKey: string): void => {
    setCollapsedGroups((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(buildingKey)) {
        newSet.delete(buildingKey);
      } else {
        newSet.add(buildingKey);
      }
      return newSet;
    });
  };

  // Check if any filters are active
  const hasActiveFilters = search !== '' || selectedBuildings.length > 0 || selectedOptionTypes.length < ALL_OPTION_TYPES.length;

  // Sync selectedItem with fresh data when rofrData changes (e.g., after status update)
  React.useEffect(() => {
    if (selectedItem && rofrData) {
      const updatedItem = rofrData.find((item) => item.id === selectedItem.id);
      if (updatedItem && JSON.stringify(updatedItem) !== JSON.stringify(selectedItem)) {
        setSelectedItem(updatedItem);
      }
    }
  }, [rofrData, selectedItem]);

  // Clear all filters
  const clearFilters = (): void => {
    setSearch('');
    setSelectedBuildings([]);
    setSelectedOptionTypes([...ALL_OPTION_TYPES]);
  };

  // Multi-select filter handlers
  const handleBuildingToggle = (building: string): void => {
    setSelectedBuildings((prev) => {
      if (prev.includes(building)) {
        return prev.filter((b) => b !== building);
      }
      return [...prev, building];
    });
  };

  const handleOptionTypeToggle = (optionType: OptionType): void => {
    setSelectedOptionTypes((prev) => {
      if (prev.includes(optionType)) {
        return prev.filter((t) => t !== optionType);
      }
      return [...prev, optionType];
    });
  };

  const handleSelectAllBuildings = (): void => {
    if (selectedBuildings.length === buildings.length) {
      setSelectedBuildings([]);
    } else {
      setSelectedBuildings([...buildings]);
    }
  };

  const handleSelectAllOptionTypes = (): void => {
    if (selectedOptionTypes.length === ALL_OPTION_TYPES.length) {
      setSelectedOptionTypes([]);
    } else {
      setSelectedOptionTypes([...ALL_OPTION_TYPES]);
    }
  };

  const { mutate: confirmOption } = useMutation(
    async (id: number) => axios({
      url: `/api/options-monitor/${id}/confirm/`,
      method: 'post',
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Option record confirmed');
      },
    },
  );

  // Mutation to update option status (uses update_status endpoint for activity logging)
  const { mutate: updateOptionStatus } = useMutation(
    async ({ id, status, note }: { id: number; status: OptionStatus; note?: string }) => axios({
      url: `/api/options-monitor/${id}/update_status/`,
      method: 'post',
      data: { option_status: status.toLowerCase(), note: note || '' },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Status updated successfully');
      },
      onError: () => {
        enqueueSnackbar('Failed to update status', { variant: 'error' });
      },
    },
  );

  // Mutation to update trigger event
  const { mutate: updateTriggerEvent } = useMutation(
    async ({ id, triggerEvent }: { id: number; triggerEvent: string }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { trigger_event: triggerEvent },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Trigger event updated');
        setEditingTriggerId(null);
        setEditingTriggerValue('');
      },
      onError: () => {
        enqueueSnackbar('Failed to update trigger event', { variant: 'error' });
      },
    },
  );

  // Mutation to update unit/suite
  const { mutate: updateUnitSuite } = useMutation(
    async ({ id, unitSuite }: { id: number; unitSuite: string }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { unit_suite: unitSuite },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Unit / Suite updated');
        setEditingUnitSuiteId(null);
        setEditingUnitSuiteValue('');
      },
      onError: () => {
        enqueueSnackbar('Failed to update unit / suite', { variant: 'error' });
      },
    },
  );

  // Mutation to update SF
  const { mutate: updateSF } = useMutation(
    async ({ id, tenantSqft }: { id: number; tenantSqft: number | null }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { tenant_sqft: tenantSqft },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('SF updated');
        setEditingSFId(null);
        setEditingSFValue('');
      },
      onError: () => {
        enqueueSnackbar('Failed to update SF', { variant: 'error' });
      },
    },
  );

  // Mutation to update notice period
  const { mutate: updateNoticePeriod } = useMutation(
    async ({ id, noticePeriod }: { id: number; noticePeriod: string }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { notice_period: noticePeriod },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Notice period updated');
        setEditingNoticePeriodId(null);
        setEditingNoticePeriodValue('');
      },
      onError: () => {
        enqueueSnackbar('Failed to update notice period', { variant: 'error' });
      },
    },
  );

  // Mutation to update rate structure
  const { mutate: updateRateStructure } = useMutation(
    async ({ id, rateStructure }: { id: number; rateStructure: string }) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'patch',
      data: { rate_structure: rateStructure },
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Rate structure updated');
      },
      onError: () => {
        enqueueSnackbar('Failed to update rate structure', { variant: 'error' });
      },
    },
  );

  const { mutate: deleteOption } = useMutation(
    async (id: number) => axios({
      url: `/api/options-monitor/${id}/`,
      method: 'delete',
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/options-monitor');
        enqueueSnackbar('Option record deleted successfully');
      },
      onError: () => {
        enqueueSnackbar('Failed to delete option record', { variant: 'error' });
      },
    },
  );

  const { mutate: bulkDeleteOptions, isLoading: isBulkDeleting } = useMutation(
    async (ids: number[]) => axios({
      url: '/api/options-monitor/bulk_delete/',
      method: 'post',
      data: { ids },
    }),
    {
      onSuccess: async (res: AxiosResponse) => {
        await queryClient.invalidateQueries('get/options-monitor');
        const count = res.data?.detail?.count ?? selectedIds.size;
        enqueueSnackbar(`${count} option record${count !== 1 ? 's' : ''} deleted`);
        setSelectedIds(new Set());
      },
      onError: () => {
        enqueueSnackbar('Failed to delete selected option records', { variant: 'error' });
      },
    },
  );

  // Bulk selection helpers
  const selectableItems = useMemo(
    () => filteredData.filter((item) => !item.is_processing),
    [filteredData],
  );

  const handleToggleSelect = (id: number): void => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const handleSelectAll = (): void => {
    if (selectedIds.size === selectableItems.length) {
      setSelectedIds(new Set());
    } else {
      setSelectedIds(new Set(selectableItems.map((item) => item.id)));
    }
  };

  // Handle inline trigger event edit
  const handleTriggerEventClick = (item: ROFRMonitorItem): void => {
    setEditingTriggerId(item.id);
    setEditingTriggerValue(item.trigger_event || '');
  };

  const handleTriggerEventSave = (id: number): void => {
    updateTriggerEvent({ id, triggerEvent: editingTriggerValue });
  };

  const handleTriggerEventCancel = (): void => {
    setEditingTriggerId(null);
    setEditingTriggerValue('');
  };

  // Handle inline unit/suite edit
  const handleUnitSuiteClick = (item: ROFRMonitorItem): void => {
    setEditingUnitSuiteId(item.id);
    setEditingUnitSuiteValue(item.unit_suite || '');
  };

  const handleUnitSuiteSave = (id: number): void => {
    updateUnitSuite({ id, unitSuite: editingUnitSuiteValue });
  };

  const handleUnitSuiteCancel = (): void => {
    setEditingUnitSuiteId(null);
    setEditingUnitSuiteValue('');
  };

  // Handle inline SF edit
  const handleSFClick = (item: ROFRMonitorItem): void => {
    setEditingSFId(item.id);
    setEditingSFValue(item.tenant_sqft ? String(item.tenant_sqft) : '');
  };

  const handleSFSave = (id: number): void => {
    const digits = editingSFValue.replace(/[^0-9]/g, '');
    const parsed = digits ? parseInt(digits, 10) : null;
    updateSF({ id, tenantSqft: parsed });
  };

  const handleSFCancel = (): void => {
    setEditingSFId(null);
    setEditingSFValue('');
  };

  // Handle inline notice period edit
  const handleNoticePeriodClick = (item: ROFRMonitorItem): void => {
    setEditingNoticePeriodId(item.id);
    setEditingNoticePeriodValue(item.notice_period || '');
  };

  const handleNoticePeriodSave = (id: number): void => {
    updateNoticePeriod({ id, noticePeriod: editingNoticePeriodValue });
  };

  const handleNoticePeriodCancel = (): void => {
    setEditingNoticePeriodId(null);
    setEditingNoticePeriodValue('');
  };

  const columns = useMemo(
    () => {
      // Building column
      const buildingColumn = {
        Header: 'Building',
        accessor: 'property_name',
        width: '9%',
        minWidth: 90,
        cellStyle: { verticalAlign: 'middle' },
        sortType: 'alphanumeric',
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { value, row } = cell;
          const item = row.original as unknown as ROFRMonitorItem;
          if (item.is_processing) {
            return (
              <span style={{ color: '#9E9E9E', fontStyle: 'italic' }}>
                Processing...
              </span>
            );
          }
          return (
            <span style={{ color: value ? '#212121' : '#9E9E9E', fontStyle: value ? 'normal' : 'italic' }}>
              {value || 'Unassigned'}
            </span>
          );
        },
      };

      // Tenant column - clickable to open sidesheet
      const tenantColumn = {
        Header: 'Tenant',
        accessor: 'tenant_name',
        width: '12%',
        minWidth: 120,
        cellStyle: { verticalAlign: 'middle' },
        disableSortBy: true,
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { value, row } = cell;
          const { original } = row;
          const item = original as unknown as ROFRMonitorItem;
          if (item.is_processing) {
            return (
              <span style={{ color: '#9E9E9E', fontStyle: 'italic' }}>
                <CircularProgress size={12} style={{ marginRight: '8px', color: '#9E9E9E' }} />
                Extracting...
              </span>
            );
          }
          const isInactive = item.option_status === 'Waived' || item.option_status === 'Exercised';
          return (
            <span
              style={{ 
                color: isInactive ? '#9CA3AF' : '#00CFA1', 
                cursor: 'pointer', 
                fontWeight: 500,
                wordBreak: 'keep-all',
                overflowWrap: 'break-word',
              }}
              onClick={(): void => {
                setSelectedItem(original as unknown as ROFRMonitorItem);
                setShowSidesheet(true);
              }}
              aria-hidden='true'
            >
              {formatTenantName(value as string)}
            </span>
          );
        },
      };

      // Unit/Suite column with click-to-edit
      const unitSuiteColumn = {
        Header: 'Unit / Suite',
        accessor: 'unit_suite',
        width: '6%',
        minWidth: 65,
        cellStyle: { verticalAlign: 'middle' },
        disableSortBy: true,
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { value, row } = cell;
          const item = row.original as unknown as ROFRMonitorItem;
          if (item.is_processing) {
            return <span style={{ color: '#9CA3AF' }}>-</span>;
          }

          const isEditing = editingUnitSuiteId === item.id;

          if (isEditing) {
            return (
              <div
                style={{ display: 'flex', alignItems: 'center', width: '100%' }}
                onClick={(e: React.MouseEvent): void => { e.stopPropagation(); }}
                aria-hidden='true'
              >
                <TextField
                  size='small'
                  value={editingUnitSuiteValue}
                  onChange={(e): void => { setEditingUnitSuiteValue(e.target.value); }}
                  onKeyDown={(e): void => {
                    if (e.key === 'Enter') {
                      handleUnitSuiteSave(item.id);
                    } else if (e.key === 'Escape') {
                      handleUnitSuiteCancel();
                    }
                  }}
                  onBlur={(): void => { handleUnitSuiteSave(item.id); }}
                  autoFocus
                  fullWidth
                  placeholder='Enter unit / suite'
                  sx={{
                    '& .MuiInputBase-input': { fontSize: '13px', padding: '4px 8px' },
                    '& .MuiOutlinedInput-root': { borderRadius: '4px' },
                  }}
                />
              </div>
            );
          }

          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                cursor: 'pointer',
              }}
              onClick={(e: React.MouseEvent): void => {
                e.stopPropagation();
                handleUnitSuiteClick(item);
              }}
              aria-hidden='true'
            >
              <span
                style={{
                  color: value ? '#212121' : '#9CA3AF',
                  fontStyle: value ? 'normal' : 'italic',
                }}
              >
                {value || 'Click to add'}
              </span>
            </div>
          );
        },
      };

      // Option Type column with colored badges
      const optionTypeColumn = {
        Header: 'Option Type',
        accessor: 'option_type',
        width: '9%',
        minWidth: 95,
        disableSortBy: true,
        cellStyle: { verticalAlign: 'middle' },
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { row } = cell;
          const item = row.original as unknown as ROFRMonitorItem;
          if (item.is_processing) {
            return <span style={{ color: '#9CA3AF' }}>-</span>;
          }
          const optionType = (item.option_type || 'ROFR') as OptionType;
          const config = OPTION_TYPE_CONFIG[optionType] || OPTION_TYPE_CONFIG.ROFR;
          const isInactive = item.option_status === 'Waived' || item.option_status === 'Exercised';
          // Show "(1 of 2)" suffix when multiple options of same type exist
          const multiLabel = (item.option_count && item.option_count > 1)
            ? ` (${item.option_index} of ${item.option_count})`
            : '';
          return (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: config.bgColor,
                color: config.color,
                border: `1px solid ${config.borderColor}`,
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: 500,
                whiteSpace: 'nowrap',
                height: '26px',
                opacity: isInactive ? 0.5 : 1,
              }}
            >
              {config.label}
              {multiLabel}
            </span>
          );
        },
      };

      // Status column with inline dropdown toggle
      const statusColumn = {
        Header: 'Status',
        accessor: 'option_status',
        width: '10%',
        minWidth: 110,
        disableSortBy: true,
        cellStyle: { verticalAlign: 'middle' },
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { row } = cell;
          const item = row.original as unknown as ROFRMonitorItem;
          const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

          if (item.is_processing) {
            return (
              <span
                style={{
                  backgroundColor: '#F3F4F6',
                  color: '#9E9E9E',
                  border: '1px solid #E5E7EB',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                }}
              >
                Processing
              </span>
            );
          }

          const status = (item.option_status || 'Active') as OptionStatus;
          const config = OPTION_STATUS_CONFIG[status] || OPTION_STATUS_CONFIG.Active;

          const handleClick = (e: React.MouseEvent<HTMLElement>): void => {
            e.stopPropagation();
            setAnchorEl(e.currentTarget);
          };

          const handleClose = (): void => {
            setAnchorEl(null);
          };

          const handleStatusChange = (newStatus: OptionStatus): void => {
            handleClose();
            if (newStatus === 'Waived' || newStatus === 'Exercised') {
              // Open sidesheet with pending status for note input
              setSelectedItem(item);
              setPendingStatusFromTable(newStatus);
              setShowSidesheet(true);
            } else {
              // Direct change for Active (reactivate)
              updateOptionStatus({ id: item.id, status: newStatus });
            }
          };

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div
                onClick={handleClick}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px',
                  cursor: 'pointer',
                  backgroundColor: config.bgColor,
                  color: config.color,
                  border: `1px solid ${config.borderColor}`,
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                  height: '26px',
                }}
                aria-hidden='true'
              >
                {config.label}
                <KeyboardArrowDownIcon style={{ fontSize: '16px' }} />
              </div>
              {item.status_note && (
                <Tooltip
                  title={item.status_note}
                  arrow
                  placement='top'
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: 280,
                        fontSize: '12px',
                        padding: '8px 12px',
                      },
                    },
                  }}
                >
                  <CommentIcon style={{ fontSize: '16px', color: '#F59E0B', cursor: 'pointer' }} />
                </Tooltip>
              )}
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{
                  style: { minWidth: '120px', marginTop: '4px' },
                }}
              >
                {ALL_OPTION_STATUSES.map((s) => {
                  const statusConfig = OPTION_STATUS_CONFIG[s];
                  return (
                    <MenuItem
                      key={s}
                      onClick={(): void => { handleStatusChange(s); }}
                    >
                      <ListItemIcon sx={{ minWidth: '28px' }}>
                        {s === status && <CheckIcon style={{ fontSize: '18px', color: '#212121' }} />}
                      </ListItemIcon>
                      <ListItemText primary={statusConfig.label} />
                    </MenuItem>
                  );
                })}
              </Menu>
            </div>
          );
        },
      };

      // Trigger Event column with click-to-edit
      const triggerEventColumn = {
        Header: 'Trigger Event',
        accessor: 'trigger_event',
        width: '11%',
        minWidth: 110,
        disableSortBy: true,
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { value, row } = cell;
          const item = row.original as unknown as ROFRMonitorItem;

          if (item.is_processing) {
            return <span style={{ color: '#9E9E9E' }}>-</span>;
          }

          const isEditing = editingTriggerId === item.id;
          const isInferred = item.trigger_event_inferred;

          if (isEditing) {
            return (
              <div
                style={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}
                onClick={(e: React.MouseEvent): void => { e.stopPropagation(); }}
                aria-hidden='true'
              >
                <TextField
                  size='small'
                  multiline
                  minRows={2}
                  maxRows={10}
                  value={editingTriggerValue}
                  onChange={(e): void => { setEditingTriggerValue(e.target.value); }}
                  onKeyDown={(e): void => {
                    if (e.key === 'Escape') {
                      handleTriggerEventCancel();
                    }
                  }}
                  onBlur={(): void => { handleTriggerEventSave(item.id); }}
                  autoFocus
                  fullWidth
                  placeholder='Enter trigger event'
                  sx={{
                    '& .MuiOutlinedInput-root': { borderRadius: '4px', padding: '4px 6px' },
                    '& .MuiInputBase-input': { fontSize: '13px', padding: 0 },
                  }}
                />
              </div>
            );
          }

          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                cursor: 'pointer',
              }}
              onClick={(e: React.MouseEvent): void => {
                e.stopPropagation();
                handleTriggerEventClick(item);
              }}
              aria-hidden='true'
            >
              <span
                style={{
                  color: value ? '#212121' : '#9CA3AF',
                  fontStyle: value ? 'normal' : 'italic',
                  wordBreak: 'keep-all',
                  overflowWrap: 'break-word',
                }}
              >
                {value || 'Click to add'}
              </span>
              <EditIcon style={{ fontSize: '12px', color: '#9CA3AF', opacity: 0.6 }} />
              {isInferred && (
                <Tooltip title='Auto-detected from lease document' placement='top'>
                  <InfoOutlinedIcon style={{ fontSize: '14px', color: '#F59E0B' }} />
                </Tooltip>
              )}
            </div>
          );
        },
      };

      // Notice Period column - editable with tooltip hint
      const noticePeriodColumn = {
        Header: 'Notice Period',
        accessor: 'notice_period',
        width: '10%',
        minWidth: 110,
        disableSortBy: true,
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { value, row } = cell;
          const item = row.original as unknown as ROFRMonitorItem;
          if (item.is_processing) {
            return <span style={{ color: '#9CA3AF' }}>-</span>;
          }
          const isEditing = editingNoticePeriodId === item.id;
          if (isEditing) {
            return (
              <div
                style={{ display: 'flex', alignItems: 'center', width: '100%' }}
                onClick={(e: React.MouseEvent): void => { e.stopPropagation(); }}
                aria-hidden='true'
              >
                <TextField
                  size='small'
                  value={editingNoticePeriodValue}
                  onChange={(e): void => { setEditingNoticePeriodValue(e.target.value); }}
                  onKeyDown={(e): void => {
                    if (e.key === 'Enter') handleNoticePeriodSave(item.id);
                    else if (e.key === 'Escape') handleNoticePeriodCancel();
                  }}
                  onBlur={(): void => { handleNoticePeriodSave(item.id); }}
                  autoFocus
                  fullWidth
                  placeholder='e.g. 30 days, 90 days'
                  sx={{
                    '& .MuiInputBase-input': { fontSize: '13px', padding: '4px 8px' },
                    '& .MuiOutlinedInput-root': { borderRadius: '4px' },
                  }}
                />
              </div>
            );
          }
          const formatNoticePeriod = (text: string): string => {
            if (!text || text.toLowerCase() === 'null') return '';
            return text.charAt(0).toUpperCase() + text.slice(1);
          };
          const displayValue = formatNoticePeriod(value as string);
          return (
            <Tooltip
              title='Enter number of days (e.g. 30 days, 90 days) so Action Status can be calculated'
              placement='top'
              componentsProps={{ tooltip: { sx: { maxWidth: 240, fontSize: '12px' } } }}
            >
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}
                onClick={(e: React.MouseEvent): void => { e.stopPropagation(); handleNoticePeriodClick(item); }}
                aria-hidden='true'
              >
                <span style={{ color: displayValue ? '#212121' : '#9CA3AF', fontStyle: displayValue ? 'normal' : 'italic', wordBreak: 'break-word', hyphens: 'auto', lineHeight: '1.4' }}>
                  {displayValue || 'Click to add'}
                </span>
                <EditIcon style={{ fontSize: '12px', color: '#9CA3AF', opacity: 0.6 }} />
              </div>
            </Tooltip>
          );
        },
      };

      // Verified By column - shows user name with checkmark
      const verifiedByColumn = {
        Header: 'Verified By',
        accessor: 'verified_by',
        width: '8%',
        minWidth: 80,
        disableSortBy: true,
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { row } = cell;
          const item = row.original as unknown as ROFRMonitorItem;
          if (item.is_processing) {
            return <span style={{ color: '#9CA3AF' }}>-</span>;
          }

          const verifiedBy = item.verified_by;
          if (!verifiedBy) {
            return (
              <span style={{ color: '#9CA3AF', fontStyle: 'italic' }}>
                Not verified
              </span>
            );
          }

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <CheckCircleIcon style={{ fontSize: '16px', color: '#00CFA1' }} />
              <span style={{ color: '#212121', fontSize: '13px' }}>
                {verifiedBy.full_name || verifiedBy.email}
              </span>
            </div>
          );
        },
      };

      // Actions column
      const actionsColumn = {
        Header: '',
        accessor: 'actions',
        width: '5%',
        minWidth: 50,
        disableSortBy: true,
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { row } = cell;
          const { original } = row;
          const item = original as unknown as ROFRMonitorItem;
          // Hide actions menu for processing rows
          if (item.is_processing) {
            return <div />;
          }
          return (
            <div
              style={{ textAlign: 'right' }}
              onClick={(e: React.MouseEvent): void => { e.stopPropagation(); }}
              aria-hidden='true'
            >
              <PopupState variant='popper' popupId='rofr-actions-popper'>
                {(popupState): JSX.Element => (
                  <div>
                    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                    <IconButton {...bindToggle(popupState)} size='small'>
                      <MoreHorizIcon />
                    </IconButton>
                    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                    <Popper {...bindPopper(popupState)} transition placement='bottom-end'>
                      {({ TransitionProps }): JSX.Element => (
                        <ClickAwayListener onClickAway={(): void => { popupState.close(); }}>
                          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                          <Fade {...TransitionProps} timeout={350}>
                            <Paper className='options-actions-popover'>
                              <div
                                className='action-btn'
                                onClick={(): void => {
                                  setSelectedItem(original as unknown as ROFRMonitorItem);
                                  setShowSidesheet(true);
                                  popupState.close();
                                }}
                                aria-hidden='true'
                              >
                                <span className='action-text'>View Details</span>
                              </div>
                              <div
                                className='action-btn'
                                onClick={(): void => {
                                  const item = original as unknown as ROFRMonitorItem;
                                  if (item.pdf_url) {
                                    const baseUrl = process.env.REACT_APP_BASE_URL ?? '';
                                    const fullUrl = item.pdf_url.startsWith('http') ? item.pdf_url : `${baseUrl}${item.pdf_url}`;
                                    window.open(fullUrl, '_blank');
                                  }
                                  popupState.close();
                                }}
                                aria-hidden='true'
                              >
                                <span className='action-text'>View Lease</span>
                              </div>
                              <div className='action-divider' />
                              <div
                                className='action-btn'
                                onClick={(): void => {
                                  setSelectedItem(original as unknown as ROFRMonitorItem);
                                  setPendingStatusFromTable('Waived');
                                  setShowSidesheet(true);
                                  popupState.close();
                                }}
                                aria-hidden='true'
                              >
                                <span className='action-text'>Mark as Waived</span>
                              </div>
                              <div
                                className='action-btn'
                                onClick={(): void => {
                                  setSelectedItem(original as unknown as ROFRMonitorItem);
                                  setPendingStatusFromTable('Exercised');
                                  setShowSidesheet(true);
                                  popupState.close();
                                }}
                                aria-hidden='true'
                              >
                                <span className='action-text'>Mark as Exercised</span>
                              </div>
                              <div className='action-divider' />
                              <div
                                className='action-btn'
                                onClick={(): void => {
                                  // TODO: Implement export functionality
                                  popupState.close();
                                }}
                                aria-hidden='true'
                              >
                                <span className='action-text'>Export</span>
                              </div>
                              <div className='action-divider' />
                              <div
                                className='action-btn action-btn-danger'
                                onClick={(): void => {
                                  setItemToDelete(original as unknown as ROFRMonitorItem);
                                  setDeleteDialogOpen(true);
                                  popupState.close();
                                }}
                                aria-hidden='true'
                              >
                                <span className='action-text'>Delete</span>
                              </div>
                            </Paper>
                          </Fade>
                        </ClickAwayListener>
                      )}
                    </Popper>
                  </div>
                )}
              </PopupState>
            </div>
          );
        },
      };

      // SF column - editable, integers only, display with comma separator
      const sfColumn = {
        Header: 'SF',
        accessor: 'tenant_sqft',
        width: '6%',
        minWidth: 85,
        disableSortBy: false,
        cellStyle: { verticalAlign: 'middle' },
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const item = cell.row.original as unknown as ROFRMonitorItem;
          if (item.is_processing) return <span style={{ color: '#9CA3AF' }}>-</span>;
          const isEditing = editingSFId === item.id;
          if (isEditing) {
            return (
              <div
                style={{ display: 'flex', alignItems: 'center', width: '100%' }}
                onClick={(e: React.MouseEvent): void => { e.stopPropagation(); }}
                aria-hidden='true'
              >
                <TextField
                  size='small'
                  value={editingSFValue}
                  onChange={(e): void => {
                    setEditingSFValue(e.target.value.replace(/[^0-9]/g, ''));
                  }}
                  onKeyDown={(e): void => {
                    if (e.key === 'Enter') handleSFSave(item.id);
                    else if (e.key === 'Escape') handleSFCancel();
                  }}
                  onBlur={(): void => { handleSFSave(item.id); }}
                  autoFocus
                  fullWidth
                  placeholder='Enter SF'
                  inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                  sx={{
                    '& .MuiInputBase-input': { fontSize: '13px', padding: '4px 8px' },
                    '& .MuiOutlinedInput-root': { borderRadius: '4px' },
                  }}
                />
              </div>
            );
          }
          return (
            <div
              style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}
              onClick={(e: React.MouseEvent): void => { e.stopPropagation(); handleSFClick(item); }}
              aria-hidden='true'
            >
              <span style={{ color: item.tenant_sqft ? '#212121' : '#9CA3AF', fontStyle: item.tenant_sqft ? 'normal' : 'italic' }}>
                {item.tenant_sqft ? item.tenant_sqft.toLocaleString() : 'Click to add'}
              </span>
              <EditIcon style={{ fontSize: '12px', color: '#9CA3AF', opacity: 0.6 }} />
            </div>
          );
        },
      };

      // % Of Building column - tenant SF as % of total building SF
      const pctOfBuildingColumn = {
        Header: '% Of Bldg',
        accessor: 'pct_of_building',
        width: '6%',
        minWidth: 80,
        disableSortBy: false,
        cellStyle: { verticalAlign: 'middle' },
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const item = cell.row.original as unknown as ROFRMonitorItem;
          if (item.is_processing) return <span style={{ color: '#9CA3AF' }}>-</span>;
          return (
            <span style={{ color: item.pct_of_building !== null ? '#212121' : '#9CA3AF' }}>
              {item.pct_of_building !== null ? `${item.pct_of_building}%` : '—'}
            </span>
          );
        },
      };

      // Rate Structure column - FMV / Fixed / CPI (dropdown selector, no border)
      const rateStructureColumn = {
        Header: 'Rate Structure',
        accessor: 'rate_structure',
        width: '7%',
        minWidth: 95,
        disableSortBy: true,
        cellStyle: { verticalAlign: 'middle' },
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const item = cell.row.original as unknown as ROFRMonitorItem;
          if (item.is_processing) return <span style={{ color: '#9CA3AF' }}>-</span>;
          return (
            <RateStructureCell
              item={item}
              onSelect={(rs): void => { updateRateStructure({ id: item.id, rateStructure: rs }); }}
            />
          );
        },
      };

      // Checkbox selection column
      const checkboxColumn = {
        Header: (
          <Checkbox
            checked={selectableItems.length > 0 && selectedIds.size === selectableItems.length}
            indeterminate={selectedIds.size > 0 && selectedIds.size < selectableItems.length}
            onChange={handleSelectAll}
            sx={{ p: 0, color: '#9CA3AF', '&.Mui-checked': { color: '#00CFA1' }, '&.MuiCheckbox-indeterminate': { color: '#00CFA1' } }}
            size='small'
          />
        ),
        accessor: 'select',
        width: '3%',
        minWidth: 40,
        disableSortBy: true,
        cellStyle: { verticalAlign: 'middle', textAlign: 'center' },
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { row } = cell;
          const item = row.original as unknown as ROFRMonitorItem;
          if (item.is_processing) return <div />;
          return (
            <Checkbox
              checked={selectedIds.has(item.id)}
              onChange={(e): void => { e.stopPropagation(); handleToggleSelect(item.id); }}
              onClick={(e): void => { e.stopPropagation(); }}
              sx={{ p: 0, color: '#9CA3AF', '&.Mui-checked': { color: '#00CFA1' } }}
              size='small'
            />
          );
        },
      };

      return [
        checkboxColumn,
        buildingColumn,
        tenantColumn,
        unitSuiteColumn,
        sfColumn,
        pctOfBuildingColumn,
        optionTypeColumn,
        statusColumn,
        {
          Header: 'Action Status',
          accessor: 'action_status',
          width: '11%',
          minWidth: 130,
          sortType: (rowA: { original: { action_status?: { days_remaining?: number } } }, rowB: { original: { action_status?: { days_remaining?: number } } }): number => {
            const a = rowA.original.action_status?.days_remaining ?? Infinity;
            const b = rowB.original.action_status?.days_remaining ?? Infinity;
            return a - b;
          },
          Cell: (cell: Cell<IDataObject>): JSX.Element => {
            const item = cell.row.original as unknown as ROFRMonitorItem;
            const actionStatus = item.action_status;

            if (!actionStatus) return <span style={{ color: '#9CA3AF' }}>—</span>;

            const colorMap: Record<string, { dot: string; text: string }> = {
              safe: { dot: '#D4A017', text: '#D4A017' },
              warning: { dot: '#E67E22', text: '#E67E22' },
              critical: { dot: '#C0392B', text: '#C0392B' },
              overdue: { dot: '#8B0000', text: '#8B0000' },
              neutral: { dot: '#9CA3AF', text: '#6B7280' },
              muted: { dot: '#D1D5DB', text: '#9CA3AF' },
            };

            const colors = colorMap[actionStatus.color_tier] || colorMap.neutral;

            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span
                    style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: colors.dot,
                      flexShrink: 0,
                    }}
                  />
                  <span
                    style={{
                      color: colors.text,
                      fontWeight: 500,
                      fontSize: '13px',
                      lineHeight: '1.3',
                    }}
                  >
                    {actionStatus.label}
                  </span>
                </div>
                {actionStatus.notice_date && (
                  <span style={{ color: '#6B7280', fontSize: '12px', marginLeft: '14px' }}>
                    Notice Date:
                    {' '}
                    {new Date(actionStatus.notice_date).toLocaleDateString('en-US', {
                      month: 'short', day: 'numeric', year: 'numeric',
                    })}
                  </span>
                )}
                {actionStatus.applies_to && (item.option_type === 'ROFR' || item.option_type === 'ROFO') && (
                  <span style={{ color: '#6B7280', fontSize: '12px', marginLeft: '14px' }}>
                    Applies To:
                    {' '}
                    {actionStatus.applies_to.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase())}
                  </span>
                )}
              </div>
            );
          },
        },
        rateStructureColumn,
        noticePeriodColumn,
        verifiedByColumn,
        actionsColumn,
      ];
    },
    [confirmOption, updateOptionStatus, updateRateStructure, updateSF, updateNoticePeriod, editingTriggerId, editingTriggerValue, editingUnitSuiteId, editingUnitSuiteValue, editingSFId, editingSFValue, editingNoticePeriodId, editingNoticePeriodValue, selectedIds, selectableItems],
  );

  return (
    <>
      <div className='options-wrapper'>
        {/* Header */}
        <div className='options-header'>
          <div className='header-title-row'>
            <div>
              <Typography className='header-text'>Options Monitor</Typography>
              <Typography variant='body2' color='textSecondary'>
                Surface lease options and deadlines that impact leasing and disposition decisions.
              </Typography>
            </div>
            <div className='header-actions'>
              <StradaSearch
                value={search}
                setSearch={setSearch}
                placeholder='Search tenants or buildings...'
              />
              {/* Upload Button */}
              <Button
                variant='contained'
                startIcon={<FileUploadIcon />}
                onClick={(): void => { navigate('/workspace/lease/upload/new'); }}
                sx={{
                  backgroundColor: '#00CFA1',
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: '6px',
                  padding: '6px 16px',
                  fontSize: '14px',
                  fontWeight: 500,
                  height: '35px',
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#00b890',
                    boxShadow: 'none',
                  },
                }}
              >
                Upload New
              </Button>
            </div>
          </div>
          <div className='header-filters-row'>
            <div className='header-filters-left'>
              {/* Building Multi-Select Filter */}
              <Button
                variant='outlined'
                size='small'
                endIcon={<KeyboardArrowDownIcon />}
                onClick={(e): void => { setBuildingMenuAnchor(e.currentTarget); }}
                sx={{
                  textTransform: 'none',
                  borderColor: '#E2E2E1',
                  color: '#212121',
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  padding: '4px 12px',
                  height: '32px',
                  fontSize: '14px',
                  '&:hover': {
                    borderColor: '#00CFA1',
                    backgroundColor: 'rgba(0, 207, 161, 0.04)',
                  },
                }}
              >
                {selectedBuildings.length === 0 || selectedBuildings.length === buildings.length
                  ? 'All Buildings'
                  : `${selectedBuildings.length} building${selectedBuildings.length > 1 ? 's' : ''}`}
              </Button>
              <Menu
                anchorEl={buildingMenuAnchor}
                open={Boolean(buildingMenuAnchor)}
                onClose={(): void => { setBuildingMenuAnchor(null); }}
                PaperProps={{ style: { maxHeight: 300, width: 280 } }}
              >
                {buildings.map((building) => (
                  <MenuItem
                    key={building}
                    onClick={(): void => { handleBuildingToggle(building); }}
                  >
                    <ListItemIcon sx={{ minWidth: '28px' }}>
                      {selectedBuildings.includes(building)
                        && <CheckIcon style={{ fontSize: '18px', color: '#212121' }} />}
                    </ListItemIcon>
                    <ListItemText
                      primary={building}
                      primaryTypographyProps={{
                        style: {
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        },
                      }}
                    />
                  </MenuItem>
                ))}
              </Menu>

              {/* Option Type Multi-Select Filter */}
              <Button
                variant='outlined'
                size='small'
                endIcon={<KeyboardArrowDownIcon />}
                onClick={(e): void => { setOptionTypeMenuAnchor(e.currentTarget); }}
                sx={{
                  textTransform: 'none',
                  borderColor: '#E2E2E1',
                  color: '#212121',
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  padding: '4px 12px',
                  height: '32px',
                  fontSize: '14px',
                  '&:hover': {
                    borderColor: '#00CFA1',
                    backgroundColor: 'rgba(0, 207, 161, 0.04)',
                  },
                }}
              >
                {selectedOptionTypes.length === ALL_OPTION_TYPES.length
                  ? 'All Option Types'
                  : `${selectedOptionTypes.length} type${selectedOptionTypes.length > 1 ? 's' : ''}`}
              </Button>
              <Menu
                anchorEl={optionTypeMenuAnchor}
                open={Boolean(optionTypeMenuAnchor)}
                onClose={(): void => { setOptionTypeMenuAnchor(null); }}
                PaperProps={{ style: { maxHeight: 300, width: 200 } }}
              >
                {ALL_OPTION_TYPES.map((optionType) => (
                  <MenuItem
                    key={optionType}
                    onClick={(): void => { handleOptionTypeToggle(optionType); }}
                  >
                    <ListItemIcon sx={{ minWidth: '28px' }}>
                      {selectedOptionTypes.includes(optionType)
                        && <CheckIcon style={{ fontSize: '18px', color: '#212121' }} />}
                    </ListItemIcon>
                    <ListItemText primary={OPTION_TYPE_CONFIG[optionType].label} />
                  </MenuItem>
                ))}
              </Menu>

              {/* Clear Filters Button */}
              {hasActiveFilters && (
                <Button
                  variant='text'
                  size='small'
                  startIcon={<ClearIcon />}
                  onClick={clearFilters}
                  sx={{
                    color: '#6B7280',
                    textTransform: 'none',
                    '&:hover': { color: '#212121' },
                  }}
                >
                  Clear
                </Button>
              )}
            </div>
            <div className='header-filters-right'>
              {/* Group by Building Checkbox */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={groupByBuilding}
                    onChange={(e): void => { setGroupByBuilding(e.target.checked); }}
                    sx={{
                      color: '#9CA3AF',
                      '&.Mui-checked': { color: '#00CFA1' },
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: '14px', color: '#212121' }}>
                    Group by building
                  </Typography>
                }
              />
            </div>
          </div>
        </div>

        {/* Processing leases indicator */}
        {processingLeases.length > 0 && (
          <div className='processing-leases-banner'>
            <CircularProgress size={16} style={{ color: '#00CFA1', marginRight: '12px' }} />
            <Typography style={{ fontSize: '14px', color: '#212121' }}>
              {processingLeases.length === 1
                ? 'Processing uploaded lease...'
                : `Processing ${processingLeases.length} uploaded leases...`}
            </Typography>
          </div>
        )}

        {/* Results count + bulk actions */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px', gap: '12px', height: '36px' }}>
          <Typography className='results-count' style={{ marginBottom: 0 }}>
            Showing
            {' '}
            {filteredData.length}
            {' '}
            of
            {' '}
            {rofrData?.length ?? 0}
            {' '}
            options
          </Typography>
          {selectedIds.size > 0 && (
            <>
              <span style={{ color: '#D1D5DB', fontSize: '14px' }}>|</span>
              <Typography style={{ fontSize: '14px', color: '#DC2626', fontWeight: 500 }}>
                {selectedIds.size}
                {' selected'}
              </Typography>
              <Button
                variant='contained'
                size='small'
                startIcon={<DeleteOutlineIcon />}
                onClick={(): void => { setBulkDeleteDialogOpen(true); }}
                disabled={isBulkDeleting}
                sx={{
                  backgroundColor: '#DC2626',
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: 500,
                  height: '28px',
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: '#B91C1C',
                    boxShadow: 'none',
                  },
                }}
              >
                {isBulkDeleting ? 'Deleting...' : `Delete Selected (${selectedIds.size})`}
              </Button>
              <Button
                variant='text'
                size='small'
                onClick={(): void => { setSelectedIds(new Set()); }}
                sx={{ color: '#6B7280', textTransform: 'none', fontSize: '13px' }}
              >
                Clear Selection
              </Button>
            </>
          )}
        </div>

        {/* Table */}
        {isLoading ? (
          <div style={{ height: '70vh' }} className='d-flex justify-content-center align-items-center'>
            <CustomLoader />
          </div>
        ) : groupByBuilding && groupedData ? (
          <div className='rofr-table-container grouped-mode'>
            {Object.keys(groupedData).sort().map((buildingKey) => {
              const buildingItems = groupedData[buildingKey];
              const isCollapsed = collapsedGroups.has(buildingKey);
              const groupPct = getUniquePctOfBuilding(buildingItems);
              return (
                <div key={buildingKey} className='building-group'>
                  <div
                    className='building-group-header'
                    onClick={(): void => { toggleGroupCollapse(buildingKey); }}
                    aria-hidden='true'
                  >
                    <IconButton size='small' sx={{ p: 0, mr: 1 }}>
                      {isCollapsed ? <KeyboardArrowRightIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                    <span className='building-group-name'>{buildingKey}</span>
                    <span className='building-group-stats'>
                      {groupPct !== null && (
                        <span className='building-group-pct'>
                          {`${groupPct}% of Bldg`}
                        </span>
                      )}
                      <span className='building-group-count'>
                        {buildingItems.length}
                        {' '}
                        option
                        {buildingItems.length !== 1 ? 's' : ''}
                      </span>
                    </span>
                  </div>
                  {!isCollapsed && (
                    <CustomTable
                      columns={columns}
                      data={buildingItems}
                      onRowClick={(row: ROFRMonitorItem): void => {
                        if (row.is_processing) return;
                        setSelectedItem(row);
                        setShowSidesheet(true);
                      }}
                      selectedRowId={selectedItem?.id}
                      getRowClassName={(row: ROFRMonitorItem): string => {
                        if (row.is_processing) return 'processing-row';
                        const s = (row.option_status || 'Active') as OptionStatus;
                        if (s === 'Waived' || s === 'Exercised') return 'inactive-row';
                        return '';
                      }}
                    />
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div className='rofr-table-container'>
            <CustomTable
              columns={columns}
              data={filteredData}
              onRowClick={(row: ROFRMonitorItem): void => {
                // Prevent clicking on processing rows
                if (row.is_processing) {
                  return;
                }
                setSelectedItem(row);
                setShowSidesheet(true);
              }}
              selectedRowId={selectedItem?.id}
              getRowClassName={(row: ROFRMonitorItem): string => {
                if (row.is_processing) return 'processing-row';
                const s = (row.option_status || 'Active') as OptionStatus;
                if (s === 'Waived' || s === 'Exercised') return 'inactive-row';
                return '';
              }}
            />
          </div>
        )}
      </div>

      {/* Backdrop overlay when sidesheet is open */}
      {showSidesheet && (
        <div
          className={`sidesheet-backdrop${isClosing ? ' closing' : ''}`}
          onClick={(): void => {
            setIsClosing(true);
            setTimeout(() => {
              setShowSidesheet(false);
              setSelectedItem(null);
              setIsClosing(false);
            }, 250);
          }}
          aria-hidden='true'
        />
      )}

      {/* Detail Sidesheet */}
      {showSidesheet && selectedItem && (
        <OptionsDetailSideSheet
          item={selectedItem}
          isClosing={isClosing}
          pendingStatusFromTable={pendingStatusFromTable}
          onClose={(): void => {
            setIsClosing(true);
            setTimeout(() => {
              setShowSidesheet(false);
              setSelectedItem(null);
              setPendingStatusFromTable(null);
              setIsClosing(false);
            }, 250);
          }}
        />
      )}

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} aria-labelledby='delete-dialog-title'>
        <DialogContent style={{ width: 400, padding: '24px' }}>
          <div className='dialog-heading' style={{ fontSize: '18px', fontWeight: 500, marginBottom: '12px' }}>
            Delete Option?
          </div>
          <span style={{ fontSize: '14px', color: 'rgba(33, 33, 33, 0.6)', fontWeight: '400' }}>
            Are you sure you want to delete this
            {' '}
            <strong>{itemToDelete?.option_type}</strong>
            {' '}
            option record for
            {' '}
            <strong>{itemToDelete?.tenant_name}</strong>
            ? This will only remove this specific option record.
          </span>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px' }}>
          <Button
            onClick={(): void => { setDeleteDialogOpen(false); setItemToDelete(null); }}
            style={{ color: '#00CFA1', textTransform: 'none' }}
          >
            Cancel
          </Button>
          <Button
            onClick={(): void => {
              if (itemToDelete) {
                deleteOption(itemToDelete.id);
              }
              setDeleteDialogOpen(false);
              setItemToDelete(null);
            }}
            style={{ textTransform: 'none', color: 'white', background: '#DC2626' }}
            variant='contained'
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Delete Confirmation Dialog */}
      <Dialog open={bulkDeleteDialogOpen} aria-labelledby='bulk-delete-dialog-title'>
        <DialogContent style={{ width: 400, padding: '24px' }}>
          <div className='dialog-heading' style={{ fontSize: '18px', fontWeight: 500, marginBottom: '12px' }}>
            {'Delete '}
            {selectedIds.size}
            {' Option'}
            {selectedIds.size !== 1 ? 's' : ''}
            ?
          </div>
          <span style={{ fontSize: '14px', color: 'rgba(33, 33, 33, 0.6)', fontWeight: '400' }}>
            {'Are you sure you want to delete '}
            <strong>
              {selectedIds.size}
            </strong>
            {' selected option record'}
            {selectedIds.size !== 1 ? 's' : ''}
            ? This action cannot be undone.
          </span>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px' }}>
          <Button
            onClick={(): void => { setBulkDeleteDialogOpen(false); }}
            style={{ color: '#00CFA1', textTransform: 'none' }}
          >
            Cancel
          </Button>
          <Button
            onClick={(): void => {
              bulkDeleteOptions([...selectedIds]);
              setBulkDeleteDialogOpen(false);
            }}
            style={{ textTransform: 'none', color: 'white', background: '#DC2626' }}
            variant='contained'
            disabled={isBulkDeleting}
          >
            {isBulkDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
